import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import Form from "@/components/Shared/Form";
import EditableImage from "@/components/EditableImage";
import EditableText from "@/components/EditableText";
import Link from "next/link"
import Wave from "@/public/site-assets/svg/location-details-wave.svg";
import TelephoneIcon from "@/public/site-assets/svg/telephone.svg";
import MailIcon from "@/public/site-assets/svg/mail.svg";
import LocationIcon from "@/public/site-assets/svg/address.svg";

export default function LocationDetails({
    className,
    global,
    pathPrefix,
    post,
    heading_1,
    heading_2,
    heading_3
}) {
    return (
        <>
            <section className={clsx(className, styles.root)}>
                <Container>
                    <div className='wrapper d-flex gap-5 flex-column-reverse flex-lg-row'>
                        {post.location_embed &&
                            <div>
                                <div dangerouslySetInnerHTML={{ __html: post.location_embed }} />
                            </div>
                        }
                        <div className={`gap-4 d-flex flex-wrap ${!post.location_embed && "w-100 justify-content-center"}`}>
                            {post?.address && (
                                <div className='item'>
                                    {heading_1 && (
                                        <div className='d-flex mb-3'>
                                            <div className='me-3'>
                                                <LocationIcon />
                                            </div>
                                            <EditableText
                                                content={heading_1}
                                                path={`${pathPrefix}.heading_1`}
                                                global={global}
                                                tag={`h3`}
                                                className={`h2`}
                                            />
                                        </div>
                                    )}
                                    <div className="ps-5 ps-lg-0" dangerouslySetInnerHTML={{ __html: post.address }} />
                                </div>
                            )}
                            {post?.telephone && (
                                <div className={`item ${!post.location_embed && "itemWithoutMap"}`}>
                                    {heading_2 && (
                                        <div className='d-flex mb-3'>
                                            <div className='me-3'>
                                                <TelephoneIcon />
                                            </div>
                                            <EditableText
                                                content={heading_2}
                                                path={`${pathPrefix}.heading_2`}
                                                global={global}
                                                tag={`h3`}
                                                className={`h2`}
                                            />
                                        </div>
                                    )}
                                    <div className='ps-5 ps-lg-0'>
                                        <Link href={`tel:${post.telephone}`}>{post.telephone}</Link>
                                    </div>
                                </div>
                            )}
                            {post?.email && (
                                <div className={`item ${!post.location_embed && "itemWithoutMap"}`}>
                                    {heading_3 && (
                                        <div className='d-flex mb-3'>
                                            <div className='me-3'>
                                                <MailIcon />
                                            </div>
                                            <EditableText
                                                content={heading_3}
                                                path={`${pathPrefix}.heading_3`}
                                                global={global}
                                                tag={`h3`}
                                                className={`h2`}
                                            />
                                        </div>
                                    )}
                                    <div className='ps-5 ps-lg-0'>
                                        <Link href={`mailto:${post.email}`} className={`text-break`}>{post.email}</Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Container>
                <div className="pt-5"></div>
                <Wave />
            </section>
        </>
    )
}

LocationDetails.defaultProps = {
    pathPrefix: "",
    className: "pt-5",
    heading_1: "Find us",
    heading_2: "Call us",
    heading_3: "Send us a message",
};

LocationDetails.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
    heading_1: PropTypes.string,
    heading_2: PropTypes.string,
    heading_3: PropTypes.string
};